import { SectionHeader } from "@/components/common/section-header";
import {
  resolveLandingPageAnchorTextColor,
  resolveLandingPageSectionBackgroundColor
} from "@/utils/landing-page-background";
import { Box } from "@mui/system";
import React from "react";

export interface TermsAndConditionsProps {
  copyText: string;
  moduleRankingPosition: string;
  testId?: string;
  copyTestId?: string;
  dataParentContainer?: string;
  dataModuleName?: string;
  backgroundColor?: string;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  copyText,
  moduleRankingPosition,
  testId = "terms-and-conditions-container",
  copyTestId = "terms-and-conditions-copy",
  dataParentContainer = "terms-and-conditions-section",
  dataModuleName = "terms and conditions",
  backgroundColor
}) => (
  <Box
    className="fluid-box"
    component="section"
    data-testid={testId}
    data-parent-container={dataParentContainer}
    data-module-name={dataModuleName}
    data-module-ranking-position={moduleRankingPosition}
    data-ranking-algorithm="manual"
    data-track="visibility"
    sx={{
      bgcolor: resolveLandingPageSectionBackgroundColor(
        backgroundColor,
        "background.cool_strong"
      )
    }}
  >
    <Box
      className="full-width-container"
      sx={{ p: { xs: "2.6rem 2.4rem", md: "2.8rem 3.2rem", lg: "2.8rem 10rem" } }}
    >
      <SectionHeader
        copyText={copyText}
        copyTestId={copyTestId}
        copySx={{
          "& a": {
            color: resolveLandingPageAnchorTextColor(backgroundColor),
            textDecoration: "underline !important"
          },
          fontSize: "1.4rem",
          textAlign: { xs: "left", md: "left" }
        }}
      />
    </Box>
  </Box>
);

export default TermsAndConditions;